module.exports = __webpack_public_path__ + "static/media/iPhone22.999eaaa2.png";